<div class="body">

    <mat-toolbar class="ams-toolbar">
        <button mat-icon-button>
            <mat-icon>history</mat-icon>
        </button>
        <span>Vorgangshistorie</span>
        <span class="spacer"></span>
        <button mat-icon-button color="warn" (click)="close()">
            <mat-icon>close</mat-icon>
        </button>
    </mat-toolbar>

    <div class="content">

        <app-issue-status-diff [issueStatus]="issueStatus"></app-issue-status-diff>
        
    </div>

    <div class="footer">

        <button mat-raised-button color="primary" (click)="tryNavigation()">
            Vorgangsdetails anzeigen
        </button>

    </div>

</div>
